import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { useTranslation } from "react-i18next";
import { Modal } from "@lib/modal";
import { Button } from "@components/buttons";
import { useFixBody } from "@state/hooks/shared";

export default observer(function CountryChangePopup() {
	const { countryChangeStore } = useRootAppStore();

	const { t } = useTranslation();

	useFixBody(true, countryChangeStore.isCountryChangePopupActive);

	return (
		<Modal>
			<div id="reuse-form" className="popup">
				<div className="popup__card popup__card--med">
					<div className="popup__header">{t("USER.POPUPS.INFO")}</div>
					<div className="popup__body">
						{countryChangeStore.errorMessage}
					</div>
					<div className="popup__footer">
						<Button
							className="popup__btn btn btn--base btn--block btn--primary--inverted"
							type="button"
							onClick={() => {
								countryChangeStore.deactivatePopupAndLogoutUser();
							}}
							btnText={t("USER.POPUPS.BUTTON_OK")}
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
});
